import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
const StorageInspector = dynamic(() => import('./StorageInspector'), {
  ssr: false,
  loading: () => null
});
export const StorageInspectorContainer = () => {
  const {
    isReady,
    query
  } = useRouter();
  const isShow = Boolean(query['debug_info']);
  if (!isReady) return null;
  if (isShow) {
    return <StorageInspector />;
  }
  return null;
};